import axios from 'axios'

const {
  REACT_APP_BACKEND_URL,
  NODE_ENV = 'development',
} = process.env

console.log('REACT_APP_BACKEND_URL', REACT_APP_BACKEND_URL)

axios.defaults.baseURL = (NODE_ENV === 'development' ? 'http://localhost:1330' : REACT_APP_BACKEND_URL)

// Add access token to request
axios.interceptors.request.use(
  config => {
    const updatedConfig = { ...config }
    const accessToken = sessionStorage.getItem('accessToken')
    if (accessToken) {
      updatedConfig.headers = {
        Authorization: `Bearer ${accessToken}`,
        ...updatedConfig.headers,
      }
    }
    return updatedConfig
  },
  error => Promise.reject(error),
)

// Queue system for handling refresh token race conditions
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

// Retry on 401 with refresh token
axios.interceptors.response.use(
  res => res,
  async err => {
    const {
      config,
      config: { _retry } = {},
      response: { status } = {},
    } = err || {}

    const originalRequest = config

    if (status === 401 && !_retry) {
      const refreshToken = localStorage.getItem('refreshToken')
        || sessionStorage.getItem('refreshToken')

      if (!refreshToken) return Promise.reject(err)

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: token => {
              originalRequest.headers.Authorization = `Bearer ${token}`
              resolve(axios(originalRequest))
            },
            reject,
          })
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const {
          data: {
            accessToken,
            refreshToken: newRefreshToken,
          } = {},
        } = await axios.post('/userRefreshAccessToken', { refreshToken })

        sessionStorage.setItem('accessToken', accessToken)
        localStorage.setItem('refreshToken', newRefreshToken)

        processQueue(null, accessToken)

        originalRequest.headers.Authorization = `Bearer ${accessToken}`
        return axios(originalRequest)
      } catch (refreshErr) {
        processQueue(refreshErr, null)
        return Promise.reject(refreshErr)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(err)
  },
)
